import script from "./NavBarCustomComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./NavBarCustomComponent.vue?vue&type=script&setup=true&lang=js"

import "./NavBarCustomComponent.vue?vue&type=style&index=0&id=5dbd3105&scoped=true&lang=css"

import exportComponent from "C:\\wamp64_old\\www\\configurator_vue_new_core_update\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5dbd3105"]])

export default __exports__